import { render, staticRenderFns } from "./PageEventABCBookReader.vue?vue&type=template&id=7ec679c2&scoped=true&"
import script from "./PageEventABCBookReader.vue?vue&type=script&lang=js&"
export * from "./PageEventABCBookReader.vue?vue&type=script&lang=js&"
import style0 from "./PageEventABCBookReader.vue?vue&type=style&index=0&id=7ec679c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec679c2",
  null
  
)

export default component.exports